import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [{
            //重定向路由
            path: '/',
            redirect: '/home'
        },
        //404
        {
            path: '*',
            component: resolve => require(['../views/others/404.vue'], resolve)
        },
        //登录
        {
            path: '/login',
            component: resolve => require(['../views/login/login.vue'], resolve)
        },
        //业务逻辑页
        {
            path: "/home",
            component: resolve => require(['../components/root/home.vue'], resolve),
            children: [
                //首页  系统首页
                {
                    path: "/",
                    component: resolve => require(['../views/system/index.vue'], resolve),
                },
                //首页  账户设置
                {
                    path: "/accountSetting",
                    component: resolve => require(['../views/system/accountSetting.vue'], resolve),
                },
                //首页  系统信息
                {
                    path: "/systemInfo",
                    component: resolve => require(['../views/system/systemInfo.vue'], resolve),
                },
                //首页  系统信息
                {
                    path: "/loginLog",
                    component: resolve => require(['../views/system/loginLog.vue'], resolve),
                },
                //商品  商品列表
                {
                    path: "/goodsList",
                    component: resolve => require(['../views/goods/goodsList.vue'], resolve),
                    // meta:{
                    //     keepAlive:true //需要被缓存的组件
                    // }
                },
                //商品  添加商品
                {
                    path: "/addGoods",
                    component: resolve => require(['../views/goods/addGoods.vue'], resolve),
                },
                //商品  修改商品
                {
                    path: "/editGoods",
                    component: resolve => require(['../views/goods/editGoods.vue'], resolve),
                },
              //  商品  库存预警
                {
                    path: "/storeWarning",
                    component: resolve => require(['../views/goods/storeWarning.vue'], resolve),
                },
                // //商品  缺货商品
                // {
                //     path: "/outOfStock",
                //     component: resolve => require(['../views/goods/outOfStock.vue'], resolve),
                // },
                // //商品  销售屏蔽
                // {
                //     path: "/salesShield",
                //     component: resolve => require(['../views/goods/salesShield.vue'], resolve),
                // },
                //商品  商品分类
                {
                    path: "/categories",
                    component: resolve => require(['../views/goods/categories.vue'], resolve),
                },
                //商品  商品单位
                {
                    path: "/goodsUnit",
                    component: resolve => require(['../views/goods/unit.vue'], resolve),
                },
                //商品  商品标签
                {
                    path: "/goodsTag",
                    component: resolve => require(['../views/goods/goodsTag.vue'], resolve),
                },
                //商品  商品品牌
                {
                    path: "/productBrand",
                    component: resolve => require(['../views/goods/productBrand.vue'], resolve),
                },
                //订单  订单列表
                {   
                    path: "/orderList",
                    component: resolve => require(['../views/order/orderList.vue'], resolve),
                    // meta:{
                    //     keepAlive:true //需要被缓存的组件
                    // }
                },
                //订单  查看订单
                {
                    path: "/orderDetail",
                    component: resolve => require(['../views/order/orderDetail.vue'], resolve),
                },
                //订单  物流信息
                {
                    path: "/logisticsInfo",
                    component: resolve => require(['../views/order/logisticsInfo.vue'], resolve),
                },
                //订单  打单拣货
                {
                    path: "/printOrder",
                    component: resolve => require(['../views/order/printOrder.vue'], resolve),
                },
                //订单 修改仓库、物流
                {
                    path: "/modifyLogistics",
                    component: resolve => require(['../views/order/modifyLogistics.vue'], resolve),
                },
                //订单  批量发货
                {
                    path: "/bulkShipment",
                    component: resolve => require(['../views/order/bulkShipment.vue'], resolve),
                },
                //订单  打印电子面单
                {
                    path: "/electronicSheet",
                    component: resolve => require(['../views/order/electronicSheet.vue'], resolve),
                },
                //订单  订单设置
                {
                    path: "/orderSetting",
                    component: resolve => require(['../views/order/orderSetting.vue'], resolve),
                },
                //订单  快递单模板
                {
                    path: "/expressOrderTemp",
                    component: resolve => require(['../views/order/expressOrderTemp.vue'], resolve),
                },
                //自定义打印项
                {
                    path: "/customizePrint",
                    component: resolve => require(['../views/order/customizePrint.vue'], resolve),
                },
                //仓库  仓库信息
                {
                    path: "/depot",
                    component: resolve => require(['../views/depot/depot.vue'], resolve),
                },
                //客户  客户管理
                {
                    path: "/customer",
                    component: resolve => require(['../views/customer/customer.vue'], resolve),
                },
                //客户  编辑资料
                {
                    path: "/editCustomer",
                    component: resolve => require(['../views/customer/editCustomer.vue'], resolve),
                },
                //客户  佣金
                {
                    path: "/onCommission",
                    component: resolve => require(['../views/customer/onCommission.vue'], resolve),
                },
                //客户  余额明细
                {
                    path: "/moneyDetial",
                    component: resolve => require(['../views/customer/moneyDetial.vue'], resolve),
                },
                //客户  等级列表
                {
                    path: "/distributionLevelConfig",
                    component: resolve => require(['../views/customer/distributionLevelConfig.vue'], resolve),
                },
                //客户  编辑等级
                {
                    path: "/editdistributionLevelConfig",
                    component: resolve => require(['../views/customer/editdistributionLevelConfig.vue'], resolve),
                },
                //客户  新增等级
                {
                    path: "/adddistributionLevelConfig",
                    component: resolve => require(['../views/customer/adddistributionLevelConfig.vue'], resolve),
                },
                //客户  提现列表
                {
                    path: "/withdrawDeposit",
                    component: resolve => require(['../views/customer/withdrawDeposit.vue'], resolve),
                },
                 //客户  分销统计
                 {
                    path: "/distributionStatistics",
                    component: resolve => require(['../views/customer/distributionStatistics.vue'], resolve),
                },
                //客户  佣金流水
                {
                    path: "/commissionFlow",
                    component: resolve => require(['../views/customer/commissionFlow.vue'], resolve),
                },
                //运营  广告列表
                {
                    path: "/advertisingList",
                    component: resolve => require(['../views/operation/advertisingList.vue'], resolve),
                },
                //运营  增加广告
                {
                    path: "/advertisement",
                    component: resolve => require(['../views/operation/advertisement.vue'], resolve),
                },
                //运营  业务员公告
                {
                    path: "/notice",
                    component: resolve => require(['../views/operation/notice.vue'], resolve),
                },
                //运营  维修列表
                {
                    path: "/serviceList",
                    component: resolve => require(['../views/operation/serviceList.vue'], resolve),
                },
                //运营  新用户余额充值
                {
                    path: "/remainNew",
                    component: resolve => require(['../views/operation/remainNew.vue'], resolve),
                },
                //运营  新用户积分充值
                {
                    path: "/pointNew",
                    component: resolve => require(['../views/operation/pointNew.vue'], resolve),
                },
                //运营  老用户余额充值
                {
                    path: "/remainOld",
                    component: resolve => require(['../views/operation/remainOld.vue'], resolve),
                },
                //运营  老用户积分充值
                {
                    path: "/pointOld",
                    component: resolve => require(['../views/operation/pointOld.vue'], resolve),
                },
                //财务管理  订单流水统计
                {
                    path: "/orderDetails",
                    component: resolve => require(['../views/finance/orderDetails.vue'], resolve),
                },
                //财务管理  预存款统计
                {
                    path: "/depositDetails",
                    component: resolve => require(['../views/finance/depositDetails.vue'], resolve),
                },
                //财务管理  预存款金额详细
                {
                    path: "/amountOfAdvanceDepositDetails",
                    component: resolve => require(['../views/finance/amountOfAdvanceDepositDetails.vue'], resolve),
                },
                //财务管理  积分统计
                {
                    path: "/integralDetails",
                    component: resolve => require(['../views/finance/integralDetails.vue'], resolve),
                },
                //业务员    管理
                {
                    path: "/salesman",
                    component: resolve => require(['../views/salesman/salesman.vue'], resolve),
                },
                //业务员管理  新增业务员
                {
                    path: "/addSalesman",
                    component: resolve => require(['../views/salesman/addSalesman.vue'], resolve),
                },
                //业务员管理  修改业务员
                {
                    path: "/editSalesman",
                    component: resolve => require(['../views/salesman/editSalesman.vue'], resolve),
                },
                //设置  角色管理
                {
                    path: "/roleManagement",
                    component: resolve => require(['../views/option/roleManagement.vue'], resolve),
                },
                //设置  角色管理 权限设置
                {
                    path: "/authoritySetting",
                    component: resolve => require(['../views/option/authoritySetting.vue'], resolve),
                },
                //设置  成员管理
                {
                    path: "/memberManagement",
                    component: resolve => require(['../views/option/memberManagement.vue'], resolve),
                },
                //设置  物流公司
                {
                    path: "/logisticsCompany",
                    component: resolve => require(['../views/option/logisticsCompany.vue'], resolve),
                },
                //设置  支付设置
                {
                    path: "/payOption",
                    component: resolve => require(['../views/option/payOption.vue'], resolve),
                },
                //设置  基本设置
                {
                    path: "/baseOption",
                    component: resolve => require(['../views/option/baseOption.vue'], resolve),
                },
                //设置  操作日志
                {
                    path: "/operationLog",
                    component: resolve => require(['../views/option/operationLog.vue'], resolve),
                },
                //统计  订单统计
                {
                    path: "/orderCounts",
                    component: resolve => require(['../views/counts/orderCounts.vue'], resolve),
                },
                //统计  地区统计
                {
                    path: "/areaCounts",
                    component: resolve => require(['../views/counts/areaCounts.vue'], resolve),
                },
                //统计  商品统计
                {
                    path: "/commodityCounts",
                    component: resolve => require(['../views/counts/commodityCounts.vue'], resolve),
                },
                //统计  客户统计
                {
                    path: "/customCounts",
                    component: resolve => require(['../views/counts/customCounts.vue'], resolve),
                },
                //统计  业绩统计
                {
                    path: "/achievementCounts",
                    component: resolve => require(['../views/counts/achievementCounts.vue'], resolve),
                },
                //促销  满减
                {
                    path: "/fullReduction",
                    component: resolve => require(['../views/promotion/fullReduction.vue'], resolve),
                },
                //促销  添加满减活动
                {
                    path: "/addFullReduction",
                    component: resolve => require(['../views/promotion/addFullReduction.vue'], resolve),
                },
                //促销  修改满减活动
                {
                    path: "/editFullReduction",
                    component: resolve => require(['../views/promotion/editFullReduction.vue'], resolve),
                },
                //促销  满赠
                {
                    path: "/fullFift",
                    component: resolve => require(['../views/promotion/fullFift.vue'], resolve),
                },
                //促销  添加满赠
                {
                    path: "/addFullFift",
                    component: resolve => require(['../views/promotion/addFullFift.vue'], resolve),
                },
                //促销  修改满赠活动
                {
                    path: "/editFullFift",
                    component: resolve => require(['../views/promotion/editFullFift.vue'], resolve),
                },
                //促销  添加折扣
                {
                    path: "/addDiscount",
                    component: resolve => require(['../views/promotion/addDiscount.vue'], resolve),
                },
                //促销  修改折扣
                {
                    path: "/editDiscount",
                    component: resolve => require(['../views/promotion/editDiscount.vue'], resolve),
                },
                //促销  优惠券
                {
                    path: "/coupon",
                    component: resolve => require(['../views/promotion/coupon.vue'], resolve),
                },
                //促销  限时折扣
                {
                    path: "/discount",
                    component: resolve => require(['../views/promotion/discount.vue'], resolve),
                },
                //促销  秒杀
                {
                    path: "/spike",
                    component: resolve => require(['../views/promotion/spike.vue'], resolve),
                },
                //促销  添加秒杀
                {
                    path: "/addSpike",
                    component: resolve => require(['../views/promotion/addSpike.vue'], resolve),
                },
                //促销  修改秒杀
                {
                    path: "/editSpike",
                    component: resolve => require(['../views/promotion/editSpike.vue'], resolve),
                },
                //促销  首页弹窗促销
                {
                    path: "/homeWindowPromotion",
                    component: resolve => require(['../views/promotion/homeWindowPromotion.vue'], resolve),
                },
                //促销  添加首页弹窗促销
                {
                    path: "/addHomeWindowPromotion",
                    component: resolve => require(['../views/promotion/addHomeWindowPromotion.vue'], resolve),
                },
                //促销  修改首页弹窗促销
                {
                    path: "/editHomeWindowPromotion",
                    component: resolve => require(['../views/promotion/editHomeWindowPromotion.vue'], resolve),
                },
                //促销  促销设置
                {
                    path: "/promotionSettings",
                    component: resolve => require(['../views/promotion/promotionSettings.vue'], resolve),
                },
                //积分兑换  礼品列表
                {
                    path: "/giftList",
                    component: resolve => require(['../views/exchange/giftList.vue'], resolve),
                },
                //积分兑换  添加礼品
                {
                    path: "/addGift",
                    component: resolve => require(['../views/exchange/addGift.vue'], resolve),
                },
                //积分兑换  礼品分类
                {
                    path: "/sortGift",
                    component: resolve => require(['../views/exchange/sortGift.vue'], resolve),
                },
                //积分兑换  兑换订单
                {
                    path: "/exchangeOrder",
                    component: resolve => require(['../views/exchange/exchangeOrder.vue'], resolve),
                },
                //积分兑换  兑换订单
                {
                    path: "/editGift",
                    component: resolve => require(['../views/exchange/editGift.vue'], resolve),
                },
                //积分兑换  兑换订单 发货确认
                {
                    path: "/exchangeShipment",
                    component: resolve => require(['../views/exchange/exchangeShipment.vue'], resolve),
                },
                //积分兑换  兑换订单 电子面单
                {
                    path: "/exchangeElectronicSheet",
                    component: resolve => require(['../views/exchange/exchangeElectronicSheet.vue'], resolve),
                },
                //积分兑换  订单拣货
                {
                    path: "/printExchangeOrder",
                    component: resolve => require(['../views/exchange/printExchangeOrder.vue'], resolve),
                },
                //积分兑换  发货点设置
                {
                    path: "/addressSetting",
                    component: resolve => require(['../views/exchange/addressSetting.vue'], resolve),
                },
                //订制
                {
                    path: "/quotationsInformation",
                    component: resolve => require(['../views/customize/quotationsInformation.vue'], resolve),
                },
                {
                    path: "/addQuotations",
                    component: resolve => require(['../views/customize/addQuotations.vue'], resolve),
                },
                {
                    path: "/viewQuotations",
                    component: resolve => require(['../views/customize/viewQuotations.vue'], resolve),
                },
                {
                    path: "/ClassifiedManage",
                    component: resolve => require(['../views/customize/ClassifiedManage.vue'], resolve),
                },
                {
                    path: "/patternInformation",
                    component: resolve => require(['../views/customize/patternInformation.vue'], resolve),
                },
                {
                    path: "/addPattern",
                    component: resolve => require(['../views/customize/addPattern.vue'], resolve),
                },
                {
                    path: "/viewPatterns",
                    component: resolve => require(['../views/customize/viewPatterns.vue'], resolve),
                },
                {
                    path: "/OnTrialList",
                    component: resolve => require(['../views/onTrialItem/OnTrialList.vue'], resolve),
                },
                {
                    path: "/addOnTrialItem",
                    component: resolve => require(['../views/onTrialItem/addOnTrialItem.vue'], resolve),
                },
                {
                    path: "/sortOnTrial",
                    component: resolve => require(['../views/onTrialItem/sortOnTrial.vue'], resolve),
                },
                {
                    path: "/onTrialOrder",
                    component: resolve => require(['../views/onTrialItem/onTrialOrder.vue'], resolve),
                },
                {
                    path: "/onTrialShipment",
                    component: resolve => require(['../views/onTrialItem/onTrialShipment.vue'], resolve),
                },
                {
                    path: "/OnTrialCommentList",
                    component: resolve => require(['../views/onTrialItem/OnTrialCommentList.vue'], resolve),
                },
                {
                    path: "/editOnTrialItem",
                    component: resolve => require(['../views/onTrialItem/editOnTrialItem.vue'], resolve),
                },
                {
                    path: "/onprintExchangeOrder",
                    component: resolve => require(['../views/onTrialItem/onprintExchangeOrder.vue'], resolve),
                },
                {
                    path: "/onTrialLabel",
                    component: resolve => require(['../views/onTrialItem/onTrialLabel.vue'], resolve),
                },
                {
                    path: "/ThemeList",
                    component: resolve => require(['../views/onTrialItem/ThemeList.vue'], resolve),
                },
                {
                    path: "/addTheme",
                    component: resolve => require(['../views/onTrialItem/addTheme.vue'], resolve),
                },
                {
                    path: "/editTheme",
                    component: resolve => require(['../views/onTrialItem/editTheme.vue'], resolve),
                },
                {
                    path: "/editComment",
                    component: resolve => require(['../views/onTrialItem/editComment.vue'], resolve),
                },
                 //订单  批量打印发货单
                {
                    path: "/batchShipPrint",
                    component: resolve => require(['../views/order/batchShipPrint.vue'], resolve),
                },
                {
                    path: "/templateList",
                    component: resolve => require(['../views/truckActivity/templateList.vue'], resolve),
                },
                {
                    path: "/addTemplate",
                    component: resolve => require(['../views/truckActivity/addTemplate.vue'], resolve),
                },
                {
                    path: "/activityList",
                    component: resolve => require(['../views/truckActivity/activityList.vue'], resolve),
                },
                {
                    path: "/addActivty",
                    component: resolve => require(['../views/truckActivity/addActivty.vue'], resolve),
                },
                {
                    path: "/activityInfo",
                    component: resolve => require(['../views/operation/activityInfo.vue'], resolve),
                },
                {
                    path: "/exchangeStatistics",
                    component: resolve => require(['../views/system/exchangeStatistics.vue'], resolve),
                }
                
            ]
        },
       
    ]
})